module.exports = __webpack_public_path__ + "img/70.e76fd475.jpg";